import { render, staticRenderFns } from "./reportArriveBus.vue?vue&type=template&id=02363153&"
import script from "./reportArriveBus.vue?vue&type=script&lang=js&"
export * from "./reportArriveBus.vue?vue&type=script&lang=js&"
import style0 from "./reportArriveBus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports